import React from "react"

import * as landingImageSectionStyles from "../../styles/landing_pages/LandingImageSection.module.css"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage from "../_base/WPImage"

export default function LandingImageSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `image-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const ancor = ChildSelector.select(
    content,
    `register`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  const agenda = ChildSelector.select(
    content,
    `agenda`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  const note = ChildSelector.select(
    content,
    `note`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <>
      <div
        className={`row ${props.className} ${landingImageSectionStyles.wrapper}`}
      >
        <div className={`col-12 ${landingImageSectionStyles.wrapperImage}`}>
          <h1>{title}</h1>
          <WPImage
            holder={content}
            selector={`img-section`}
            className={`${landingImageSectionStyles.image}`}
          />
          {(ancor || agenda) && (
            <div className={landingImageSectionStyles.contentItem}>
              {ancor && (
                <p
                  className={landingImageSectionStyles.register}
                  dangerouslySetInnerHTML={{ __html: ancor.innerHTML || "" }}
                />
              )}
              {agenda && (
                <p
                  className={landingImageSectionStyles.agenda}
                  dangerouslySetInnerHTML={{ __html: agenda.innerHTML || "" }}
                />
              )}
            </div>
          )}
          {note && (
            <div className={landingImageSectionStyles.note}>
              <span>{note}</span>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
